import { RootState } from '@store/index'
import { useSelector } from 'react-redux'
import type { ReportMetricSchema } from '@services/api/report.api'

export const useReportMetricsSchema = (): ReportMetricSchema[] => {
  const reportsTemplate = useSelector(
    (state: RootState) => state.reportsTemplate.data,
  )
  return reportsTemplate?.metricsSchema ?? []
}
